import {APP_BOOTSTRAP_LISTENER, ModuleWithProviders, NgModule} from "@angular/core";
import {DOMModalRenderer} from "./dom/DOMModalRenderer";
import {ModalRenderer} from "./ModalRenderer";
import {ModalService} from "./ModalService";
// BUG: do not fix path, see https://github.com/dherges/ng-packagr/issues/734
import {
  NModalBackdropComponent,
  NModalBodyComponent,
  NModalCloseButtonComponent,
  NModalFooterComponent,
  NModalHeaderComponent,
  NModalLayerComponent,
} from "./components/public_components";

import {closeModalOnEsc} from "./closeModalOnEsc";
import {CommonModule} from "@angular/common";
import {ModalEventsService} from "./ModalEventsService";
import {NStickyModule} from "n-framework/n-sticky";


const ENTRY_COMPONENTS = [
  NModalLayerComponent,
  NModalBackdropComponent
];

const PUBLIC_COMPONENTS = [
  NModalHeaderComponent,
  NModalBodyComponent,
  NModalCloseButtonComponent,
  NModalFooterComponent,
  ...ENTRY_COMPONENTS
];


@NgModule({
  declarations: [
    ...PUBLIC_COMPONENTS
  ], // directives, components, and pipes owned by this NgModule
  imports: [
    CommonModule,
    NStickyModule,
  ],
  exports: [
    ...PUBLIC_COMPONENTS
  ],
  providers: [
    ModalService,
    {provide: ModalRenderer, useClass: DOMModalRenderer},
    {
      provide: APP_BOOTSTRAP_LISTENER,
      multi: true,
      useFactory: closeModalOnEsc,
      deps: [ModalService]
    }
  ],
  entryComponents: [
    ...ENTRY_COMPONENTS
  ]
})
export class NModalModule {
  static forRoot(): ModuleWithProviders<NModalModule> {
    return {
      ngModule: NModalModule,
      providers: [ModalEventsService]
    };
  }
}
